/**
 * package: com.inq.flash.client.chatskins
 * class: VideoPlayerBase
 * @constructor
 */
com.inq.flash.client.chatskins.VideoPlayerBase = function() {
	this._completed = false;
	/** @type {string} */
	this.state = this.STATE.NOT_INITIALIZED;
	/** @type {(s7viewers.VideoViewer|object)} */
	this.viewer = null;
	/** @type {string} */
	this.viewerConsN = "";
};

/**
 *
 * @param {string} type
 * @return {(com.inq.flash.client.chatskins.VideoPlayerScene7|object)}
 */
com.inq.flash.client.chatskins.VideoPlayerBase.init = function(type) {
	return com.inq.flash.client.chatskins.VideoPlayerBase.getImpl(type);
};
/**
 * @param {String} type
 * @return {(com.inq.flash.client.chatskins.VideoPlayerScene7|object)}
 */
com.inq.flash.client.chatskins.VideoPlayerBase.getImpl = function (type){
	var impl = null;
	if(type === "AdobeS7") {
		impl = new com.inq.flash.client.chatskins.VideoPlayerScene7();
	}
	return impl;
};
/**
 * Loads external JS file to implement the media player.
 * It is defined in MXML skin configuration as element '<mx:VideoPlayer />'.
 *    For example:
 *    <mx:VideoPlayer id="player1" type="AdobeS7" src="http://s7d1.scene7.com/s7viewers/html5/js/VideoViewer.js"/>
 * @param src {String}
 * @param pObj {com.inq.ui.VideoPlayer}
 */
com.inq.flash.client.chatskins.VideoPlayerBase.loadExternalScript = function (src, pObj) {
	var _pOjb = pObj.pInst, isDiv = _pOjb.isDivC(), tW = window.top;
	if (_pOjb == null) {
		return;
	}
	var pWindow = _pOjb.viewerConsN in window ? window : _pOjb.viewerConsN in tW ? tW : null;
	if (pWindow && pWindow[_pOjb.viewerConsN][_pOjb.viewerName]) {
		pObj.loadedScript();
		return;
	}
	var fSct = (isDiv ? tW.document : document).scripts[0];
	var nSct = (isDiv ? tW.document : document).createElement('script');

	nSct.onload = function () {
		pObj.loadedScript();
	};
	nSct.onreadystatechange = function () {
		if (nSct.readyState == 'loaded') {
			pObj.loadedScript();
		}
	};
	nSct.src = src;
	fSct.parentElement.insertBefore(nSct, fSct);

};

/**
 * Initializes the media player and starts of playback.
 * @this {com.inq.flash.client.chatskins.VideoPlayerScene7}
 */
com.inq.flash.client.chatskins.VideoPlayerBase.prototype.play = function () {
	/** if status is not started then initialize and start */
	if (this.isPaused()) {
		this.resume();
	} else if (!this.isInitialized()) {
		this.initPlay();
	}
};

/**
 * Implementation of interface for PAUSE action.
 */
com.inq.flash.client.chatskins.VideoPlayerBase.prototype.pause = function () {
};

/**
 * Implementation of interface for CLOSE action.
 */
com.inq.flash.client.chatskins.VideoPlayerBase.prototype.close = function () {
};

com.inq.flash.client.chatskins.VideoPlayerBase.prototype.sendToAgent = function (msg, action) {
	com.inq.flash.client.chatskins.SkinControl.getApplicationController().sendVideoStatusMessage(msg, this.name, action);
};

com.inq.flash.client.chatskins.VideoPlayerBase.prototype.isDivC = function () {
	return (com.inq.utils.Util.getConfig("divSkin", false) || com.inq.ui.SkinLoader.skinInClient);
};

/**
 * Resets the state of media player (viewer) instance.
 */
com.inq.flash.client.chatskins.VideoPlayerBase.prototype.reset = function() {
	this.viewer = null;
	this.state = this.STATE.NOT_INITIALIZED;
};

/**
 * Sets the state of media player to INITIALIZED:
 *    value "0"
 *    means that it initialized but media file not loaded yet
 */
com.inq.flash.client.chatskins.VideoPlayerBase.prototype.initialized = function() {
	this.state = this.STATE.INITIALIZED;
};

/**
 * Checks and returns the initialization status.
 * @return {boolean}
 */
com.inq.flash.client.chatskins.VideoPlayerBase.prototype.isInitialized = function() {
	return this.state !== this.STATE.NOT_INITIALIZED;
};

/**
 * Sets the state of media player to LOADED:
 *    value "1"
 *    means that media file is loaded
 */
com.inq.flash.client.chatskins.VideoPlayerBase.prototype.loaded = function() {
	this.state = this.STATE.LOADED;
};

/**
 * Checks and returns the status of media file loading.
 * @return {boolean}
 */
com.inq.flash.client.chatskins.VideoPlayerBase.prototype.isLoaded = function() {
	return this.isInitialized() && this.state !== this.STATE.INITIALIZED;
};

/**
 * Sets the state of media player to PAUSE:
 *    value "2"
 *    means that media playback stopped/paused
 */
com.inq.flash.client.chatskins.VideoPlayerBase.prototype.paused = function() {
	this.state = this.STATE.PAUSED;
};

/**
 * Returns the status of media file playback/pause.
 * @return {boolean}
 */
com.inq.flash.client.chatskins.VideoPlayerBase.prototype.isPaused = function() {
	return this.state === this.STATE.PAUSED;
};

/**
 * Sets the state of media player to PLAY:
 *    value "3"
 *    means that media is playing
 */
com.inq.flash.client.chatskins.VideoPlayerBase.prototype.played = function() {
	this.state = this.STATE.PLAYING;
};

/**
 * Returns the status of media file playback/pause.
 * @return {boolean}
 */
com.inq.flash.client.chatskins.VideoPlayerBase.prototype.isPlaying = function() {
	return this.state === this.STATE.PLAYING;
};

/**
 * Sets the state of media player to COMPLETED:
 *    value "4"
 *    means that media playback is completed
 */
com.inq.flash.client.chatskins.VideoPlayerBase.prototype.completed = function() {
	this._completed = true;
	this.state = this.STATE.COMPLETED;
};

/**
 * Returns the status of completion of media file playback.
 * @return {boolean}
 */
com.inq.flash.client.chatskins.VideoPlayerBase.prototype.isCompleted = function() {
	return this._completed || this.state === this.STATE.COMPLETED;
};

/** @type {string} defines constant of message text */
com.inq.flash.client.chatskins.VideoPlayerBase.DISPLAY = "Video player is displayed.";
com.inq.flash.client.chatskins.VideoPlayerBase.PLAY = "The user is playing the video: ";
com.inq.flash.client.chatskins.VideoPlayerBase.PAUSE = "The user has paused the video.";
com.inq.flash.client.chatskins.VideoPlayerBase.RESUME = "The user has resumed the video ";
com.inq.flash.client.chatskins.VideoPlayerBase.CLOSE = "The user has closed the video.";
com.inq.flash.client.chatskins.VideoPlayerBase.SEEK = "The user has seeked the video ";
com.inq.flash.client.chatskins.VideoPlayerBase.HIDDEN = "Video player is hidden.";

/** @type {object} Map of media player statuses */
com.inq.flash.client.chatskins.VideoPlayerBase.prototype.STATE = {};
/** @type {string} "-1" - player is NOT INITIALIZED, DEFAULT value */
com.inq.flash.client.chatskins.VideoPlayerBase.prototype.STATE.NOT_INITIALIZED = "-1";
/** @type {string} "0" - initial state */
com.inq.flash.client.chatskins.VideoPlayerBase.prototype.STATE.INITIALIZED = "0";
/** @type {string} "1" - media is loaded */
com.inq.flash.client.chatskins.VideoPlayerBase.prototype.STATE.LOADED = "1";
/** @type {string} "2" - media is paused */
com.inq.flash.client.chatskins.VideoPlayerBase.prototype.STATE.PAUSED = "2";
/** @type {string} "3" - media is playing */
com.inq.flash.client.chatskins.VideoPlayerBase.prototype.STATE.PLAYING = "3";
/** @type {string} "4" - media is completed */
com.inq.flash.client.chatskins.VideoPlayerBase.prototype.STATE.COMPLETED = "4";
